module.exports = __webpack_public_path__ + "static/media/cheimsford_logo.11822295.svg";